import SelectSummary from './selection_summary';

export default SelectSummary;
